module.exports = __webpack_public_path__ + "static/media/camera.5dc8d52a.svg";